import { format, isDate, parseISO } from "date-fns";

export const formatarData = (valor, formato = "dd/MM/yyyy") => {
  if (isDate(valor)) return format(valor, formato);
  return format(parseISO(valor), formato);
};

export const formatarDataHora = (valor, formato = "dd/MM/yy HH:mm") => {
  if (isDate(valor)) return format(valor, formato);
  return format(parseISO(valor), formato);
};
